import { combineReducers } from 'redux'
import {
  LOADING_ON,
  CHAT_LIST_DATA_LOAD,
  CHATROOM_DATA_LOAD,
  SELECT_CHAT,
  ADD_NEW_MESSAGE
} from '../constants/actionTypes'

// reducer.. ㅇㅏㅂ젴ㅌ
const initialState = {
  chats: [],
  isLoading: true,
  selectedChatId: null
}

function chatsReducer (state = initialState.chats, action) {
  const newState = state.slice()
  let chat

  switch (action.type) {
    case CHAT_LIST_DATA_LOAD:
      const copy = action.data.slice()

      copy.sort((a, b) => {
        const createdAtA = new Date(a.lastMessage.created_at)
        const createdAtB = new Date(b.lastMessage.created_at)

        if (createdAtA < createdAtB) {
          return 1
        } else if (createdAtA > createdAtB) {
          return -1
        } else {
          return 0
        }
      })

      return copy
    case CHATROOM_DATA_LOAD:
      const { id, messages } = action.data
      chat = newState.find(c => c.id === id)

      chat.messages = messages

      return newState
    case ADD_NEW_MESSAGE:
      const { message, chatId } = action
      chat = newState.find(c => c.id === chatId)

      chat.messages.push(message)

      // TODO: do not store dup data
      chat.lastMessage = message
      newState.splice(newState.indexOf(chat), 1)
      newState.unshift(chat)

      return newState
    default:
      return state
  }
}

function loadingReducer (state = initialState.isLoading, action) {
  switch (action.type) {
    case CHAT_LIST_DATA_LOAD:
    case CHATROOM_DATA_LOAD:
      return false
    case LOADING_ON:
      return true
    default:
      return state
  }
}

function selectedChatIdReducer (state = initialState.selectedChatId, action) {
  switch (action.type) {
    case SELECT_CHAT:
      return Number(action.chatId)
    default:
      return state
  }
}

export default combineReducers({
  chats: chatsReducer,
  isLoading: loadingReducer,
  selectedChatId: selectedChatIdReducer
})
